import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import { FormattedMessage } from 'react-intl';

import ErrorDisplay, { ExtendedErrorDisplayProps } from '..';

import messages from './messages';

const ServiceError = (props: ExtendedErrorDisplayProps) => {
  return (
    <ErrorDisplay Icon={ErrorIcon} {...props}>
      <FormattedMessage {...messages.message} />
    </ErrorDisplay>
  );
};

export default ServiceError;
